export default __webpack_public_path__ + "static/media/sound-off.60151c98.svg";